import React from 'react'

const VARIANT_CLASSES = {
  running: 'bg-[#00d4aa]/15 text-[#00d4aa] border-[#00d4aa]/30',
  ready: 'bg-emerald-500/20 text-emerald-300 border-emerald-500/30',
  completed: 'bg-emerald-500/20 text-emerald-300 border-emerald-500/30',
  failed: 'bg-red-500/20 text-red-300 border-red-500/30',
  pending: 'bg-amber-500/20 text-amber-300 border-amber-500/30',
  cancelled: 'bg-white/10 text-white/50 border-white/10',
  analyzing: 'bg-blue-500/20 text-blue-300 border-blue-500/30',
  mastering: 'bg-[#00d4aa]/15 text-[#00d4aa] border-[#00d4aa]/30',
  uploaded: 'bg-sky-500/20 text-sky-300 border-sky-500/30',
  default: 'bg-white/10 text-white/70 border-white/10',
  // Genre-Farben (für Genre-Badge)
  genreRock: 'bg-amber-600/25 text-amber-200 border-amber-500/40',
  genreMetal: 'bg-stone-500/25 text-stone-200 border-stone-500/40',
  genreElectronic: 'bg-violet-500/25 text-violet-200 border-violet-500/40',
  genreHouse: 'bg-fuchsia-500/25 text-fuchsia-200 border-fuchsia-500/40',
  genreLoFi: 'bg-rose-500/25 text-rose-200 border-rose-500/40',
  genreHipHop: 'bg-emerald-500/25 text-emerald-200 border-emerald-500/40',
  genrePop: 'bg-pink-500/25 text-pink-200 border-pink-500/40',
  genreLatin: 'bg-orange-500/25 text-orange-200 border-orange-500/40',
  genreJazz: 'bg-yellow-600/25 text-amber-200 border-yellow-500/40',
  genreClassical: 'bg-slate-500/25 text-slate-200 border-slate-500/40',
  genreAmbient: 'bg-cyan-500/20 text-cyan-200 border-cyan-500/30',
  genreOther: 'bg-white/10 text-white/70 border-white/20',
}

/** Genre-String → Badge-Variant für farbige Genre-Badges */
export function getGenreBadgeVariant(genre) {
  if (!genre || typeof genre !== 'string') return 'genreOther'
  const g = genre.trim().toLowerCase()
  if (/rock|punk|indie|alternative/i.test(g)) return 'genreRock'
  if (/metal|heavy/i.test(g)) return 'genreMetal'
  if (/house|techno|tech house|melodic house|deep house|electronic|edm/i.test(g)) return 'genreHouse'
  if (/lo-fi|lofi|chillhop|chill hop/i.test(g)) return 'genreLoFi'
  if (/ambient/i.test(g)) return 'genreAmbient'
  if (/hip-hop|hiphop|rap|trap|deutschrap/i.test(g)) return 'genreHipHop'
  if (/pop|schlager|dance pop|synth pop/i.test(g)) return 'genrePop'
  if (/latin|reggaeton|salsa|bachata|cumbia|bossa|reggae|dancehall|afrobeats/i.test(g)) return 'genreLatin'
  if (/jazz|blues|soul|r&b|funk|gospel/i.test(g)) return 'genreJazz'
  if (/classical|film score|orchestral/i.test(g)) return 'genreClassical'
  if (/country|folk|singer|singer-songwriter|chanson|volksmusik|world/i.test(g)) return 'genreOther'
  return 'genreOther'
}

export default function Badge({ children, variant = 'default', className = '' }) {
  const classes = VARIANT_CLASSES[variant] ?? VARIANT_CLASSES.default
  return (
    <span className={`inline-flex items-center rounded-lg border px-2.5 py-1 text-xs font-medium ${classes} ${className}`}>
      {children}
    </span>
  )
}
